import { useCallback, useEffect, useMemo, useState } from "react";
import { genericGet } from "services/services.general";
import { getFormattedOptions } from "utility/helpers";

const usePositions = () => {
  const [positions, setPositions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    genericGet({
      url: "/position",
      callback: (data) => {
        setPositions(data);
        setIsLoading(false);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", positions);
  }, [positions]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: positions,
    isLoading,
    refetch,
    options,
  };
};

export default usePositions;
